// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"127": "90b501caafb2","2162": "50116afa419c","4278": "4c0635769556","6863": "454c9f289029",}[chunkId] + ".css"
}